import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../context/AppContext';
import { trackPixelEvent } from '../../utils/pixel';
import { LandingTrans } from '../../utils/translations';
import Navbar from '../landing/Navbar';
import Hero from '../landing/Hero';
import TestimonialStrip from '../landing/TestimonialStrip';
import WhySection from '../landing/WhySection';
import SafetyCallout from '../landing/SafetyCallout';
import FormatsSection from '../landing/FormatsSection';
import PracticeSection from '../landing/PracticeSection';
import PricingSection from '../landing/PricingSection';
import AboutSection from '../landing/AboutSection';
import HowToSection from '../landing/HowToSection';
import ContactSection from '../landing/ContactSection';
import LandingScheduleSection from '../landing/LandingScheduleSection';
import LandingDividerImage from '../../assets/photos/split-library.jpg';
import '../../styles/landing.css';

export default function LandingPage() {
  const { setToaster, language } = useAppContext();
  const navigate = useNavigate();
  const practiceRef = useRef(null);
  const formatsRef = useRef(null);
  const pricesRef = useRef(null);
  const aboutRef = useRef(null);
  const contactsRef = useRef(null);
  const scheduleRef = useRef(null);

  const refs = {
    practice: practiceRef,
    formats: formatsRef,
    schedule: scheduleRef,
    prices: pricesRef,
    about: aboutRef,
    contacts: contactsRef,
  };

  const scrollToRef = (ref) => {
    ref?.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleLearnMore = () => {
    trackPixelEvent('NavigateToSeeMoreLandingPage');
    scrollToRef(aboutRef);
  };

  const handleSignUp = () => {
    trackPixelEvent('NavigateToBooking');
    navigate('/schedule');
  };

  const handleFormSuccess = () => {
    setToaster({
      message: LandingTrans[language].formSuccessMessage,
      type: 'success',
      show: true,
    });
  };

  return (
    <main className="landing-page min-h-screen scroll-smooth font-sans antialiased">
      <Navbar scrollToRef={scrollToRef} refs={refs} onSignUp={handleSignUp} />

      <Hero onLearnMore={handleLearnMore} onSignUp={handleSignUp} />

      <TestimonialStrip />

      {/* <WhySection /> */}

      <div ref={practiceRef}>
        <PracticeSection />
      </div>

      <div className="w-full overflow-hidden">
        <img
          src={LandingDividerImage}
          alt=""
          className="w-full h-auto object-cover block"
          loading="lazy"
        />
      </div>

      <div ref={formatsRef}>
        <FormatsSection />
      </div>

      <div ref={scheduleRef}>
        <LandingScheduleSection />
      </div>

      <SafetyCallout />

      <div ref={pricesRef}>
        <PricingSection />
      </div>

      <div ref={aboutRef}>
        <AboutSection />
      </div>


      <HowToSection />

      <div ref={contactsRef}>
        <ContactSection onFormSuccess={handleFormSuccess} />
      </div>
    </main>
  );
}
